import React from 'react';
import { Footer as DsFooter } from '@vmos2/design-system';
import { NativeFooter } from '@vmos2/cordova';

export const Footer = () => {
  return <DsFooter isFixed hasShadow bottomSide={<NativeFooter />} />;
};
